/* Import necessary libraries and modules */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Admin from "apis/Admin";
import { mapKeys } from "lodash";

/* Define an asynchronous thunk for fetching verified user data */
export const verifiedUserRequest = createAsyncThunk(
  "verifiedUserList",
  async ({ data, start, limit }) => {
    try {
      /* Make an asynchronous request to fetch user data */
      const response = await Admin.post(`allUsers/${start}/${limit}`, data);
      return response.data.data;
    } catch (error) {
      /* Handle errors appropriately */
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);

// Move to Pending User
export const pendingUserRequest = createAsyncThunk(
  'pendingUser',
  async ({ data }) => {
    await Admin.post('updateUserStatus', data);
    return data;
  }
);

/* Create a Redux slice for managing verified user data state */
const verifiedUserSlice = createSlice({
  name: "verifiedUser",
  initialState: {
    /* Initial state for the verifiedUser slice */
    verifiedUser: {}, /* Holds user data with _id as the key */
    totalList: "", /* Total number of users */
    message: "", /* Any additional message related to the data */
    loading: false, /* Loading state indicator */
  },
  reducers: {
    /* You can add standard reducer logic here if needed */
  },
  extraReducers: {
    /* Add reducers for additional action types here, and handle loading state as needed */

    /* Handle the successful completion of the verifiedUserRequest */
    [verifiedUserRequest.fulfilled]: (state, action) => {
      /* Update the state with the fetched user data */
      console.log(state, "verifiedUserRequest");
      return {
        ...state,
        verifiedUser: { ...mapKeys(action.payload.users, "_id") },
        totalList: action.payload.totalUsers,
        message: action.payload.message,
        loading: false,
      };
    },

    /* Handle the pending state of the verifiedUserRequest */
    [verifiedUserRequest.pending]: (state) => {
      /* Update the loading state to indicate the request is pending */
      return { ...state, loading: true };
    },

    /* Handle the rejection (error) state of the verifiedUserRequest */
    [verifiedUserRequest.rejected]: (state, _action) => {
      /* Reset verifiedUser to an empty object in case of rejection */
      return {
        ...state,
        verifiedUser: {},
        message: "no data",
        loading: false,
      };
    },
    [pendingUserRequest.pending]: state => {
      return { ...state, loading: true };
    },
    [pendingUserRequest.rejected]: state => {
      return {
        ...state,
        loading: false,
      };
    },
    [pendingUserRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        message: action.payload.message,
        loading: false,
      };
    },
  },
});

/* Export the reducer for integration with the Redux store */
export default verifiedUserSlice.reducer;
